import GraphQLInterfaceV1 from './GraphQLInterfaceV1';
import { GraphQLInterfaceV1Type } from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

let graphQLInterfaceV1: GraphQLInterfaceV1;

export default async function initializeGraphQLInterfaceV1(): Promise<GraphQLInterfaceV1Type> {
  if (graphQLInterfaceV1) return graphQLInterfaceV1.getInterface();
  graphQLInterfaceV1 = new GraphQLInterfaceV1();
  return graphQLInterfaceV1.getInterface();
}

export function createNoopGraphQLInterface(): GraphQLInterfaceV1Type {
  return {
    query: (_query: string, _variables?: Record<string, any>) => {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopGraphQLInterface',
        methodName: 'query()',
        message: 'Noop interface method called - returning null'
      });
      return null;
    },
    mutate: (_mutation: string, _variables?: Record<string, any>) => {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopGraphQLInterface',
        methodName: 'mutate()',
        message: 'Noop interface method called - returning null'
      });
      return null;
    },
    getClient: () => {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopGraphQLInterface',
        methodName: 'getClient()',
        message: 'Noop interface method called - returning null'
      });
      return null;
    },
    gql: null,
    reactTools: {
      /* istanbul ignore next */
      createGraphQLProvider: () => {
        internalLogger?.debug?.d5({
          className: 'createNoopGraphQLInterface',
          methodName: 'reactTools.createGraphQLProvider()',
          message: 'Noop interface method called - returning null'
        });
        return null;
      },
      useQuery: () => {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopGraphQLInterface',
          methodName: 'reactTools.useQuery()',
          message: 'Noop interface method called - returning null'
        });
        return null;
      },
      useMutation: () => {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopGraphQLInterface',
          methodName: 'reactTools.useMutation()',
          message: 'Noop interface method called - returning null'
        });
        return null;
      },
      useLazyQuery: () => {
        /* istanbul ignore next */
        internalLogger?.debug?.d5({
          className: 'createNoopGraphQLInterface',
          methodName: 'reactTools.useLazyQuery()',
          message: 'Noop interface method called - returning null'
        });
        return null;
      }
    }
  };
}
